module.exports = __webpack_public_path__ + "static/media/bg39.f9697b45.jpg";